import axios from 'axios'

const URL_PATH = '/flowbee/api/public'
class FlowbeeApiClient {
	async buscarConfiguracoes(header) {
		return await axios.get(`${URL_PATH}/configuracoes`, {
			headers: header,
		})
	}
}

export default new FlowbeeApiClient()
